'use client';

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { styled } from '@mui/material/styles';
import AppBar from 'components/layout/AppBar';
import SideBar from 'components/layout/Sidebar';
import { PAGE_LIST } from 'constant/pages';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getKeyFromLocalStorage } from 'utils/constant';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

export default function AppLayout() {
  const [open, setOpen] = useState<boolean>(true);
  const handleDrawerToggle = () => {
    setOpen((oldState) => !oldState);
  };
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const appId = getKeyFromLocalStorage('appId');
    const appKey = getKeyFromLocalStorage('appKey');
    if (!appId || !appKey) navigate(PAGE_LIST.SETTING.pathname());
  }, []);

  useEffect(() => {
    if (
      pathname &&
      Object.values(PAGE_LIST)
        .map(({ pathname }) => pathname())
        .includes(pathname)
    ) {
      setOpen(false);
    }
  }, [pathname]);

  return (
    <Box sx={{ display: 'flex', overflow: 'hidden' }}>
      <CssBaseline />
      <AppBar open={open} handleDrawerToggle={handleDrawerToggle} />
      <SideBar open={open} handleClose={handleDrawerToggle} />
      <Main
        sx={{
          width: '100%',
          position: 'relative',
        }}
      >
        <Outlet />
      </Main>
    </Box>
  );
}
